/**
 * Maintenance-margin rate used for the liquidation check. Binance's lowest
 * tier — the most forgiving one, so the model never liquidates a position the
 * real exchange would have kept open.
 */
export const MAINTENANCE_MARGIN_RATE = 0.005;
/**
 * The price at which an adverse move has consumed the margin, less the
 * exchange's maintenance buffer.
 *
 * Longs are liquidated by a fall, shorts by a rise — and a short's loss is
 * unbounded above, which is exactly why this is computed rather than assumed
 * symmetric. At 1× the long price sits at or below zero (unreachable) while the
 * short price sits near 2× entry.
 *
 * Checked **before** any stop, because that is the order the exchange applies
 * them in: a leveraged position can be closed out by the venue before the
 * strategy's own stop is ever touched. Modelling the stop first reports
 * positions surviving moves that would have ended them.
 */
export function liquidationPriceFor(direction, entryPrice, leverage) {
    const marginFraction = 1 / leverage - MAINTENANCE_MARGIN_RATE;
    return direction === "long" ? entryPrice * (1 - marginFraction) : entryPrice * (1 + marginFraction);
}
/**
 * The liquidation price, or null when there is no reachable one.
 *
 * At 1× a long's liquidation price is at or below zero. Returning null rather
 * than a negative number keeps the per-bar check a null test instead of a
 * comparison that can never fire, and keeps the recorded position honest about
 * the fact that it cannot be liquidated.
 */
export function liquidationPriceOrNull(direction, entryPrice, leverage) {
    if (!Number.isFinite(leverage) || leverage <= 1)
        return null;
    const price = liquidationPriceFor(direction, entryPrice, leverage);
    if (!Number.isFinite(price) || price <= 0)
        return null;
    return price;
}
//# sourceMappingURL=liquidation.js.map